import React, { useEffect, useState } from "react";
import { MessageSquareText, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useConfirm } from "../context/ConfirmContext";
import { GroupReplies } from "./GroupReplies";

export const HostGroupText = () => {
  const confirm = useConfirm();
  const [status, setStatus] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/portal/cell/group-text").then(({ data }) => setStatus(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!status) return null;
  const left = Math.max(0, status.limit - status.used);
  const send = async () => {
    if (msg.trim().length < 2) return toast.error("Write a short message first");
    if (!(await confirm({ title: "Text your whole group?", description: "Everyone in your group who has a phone number gets this text from the church number. Their numbers stay private.", confirmLabel: "Send text" }))) return;
    setBusy(true);
    try {
      const { data } = await api.post("/portal/cell/group-text", { message: msg.trim() });
      const t = `Sent to ${data.sent}${data.no_phone ? ` · ${data.no_phone} without a phone` : ""}${data.failed ? ` · ${data.failed} failed` : ""}`;
      if (!data.sent && data.failed) toast.error(t); else toast.success(t);
      setMsg(""); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-5 rounded-xl border p-4" style={{ borderColor: "var(--sj-border)", background: "#FBFAF7" }} data-testid="host-group-text">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-sm font-semibold flex items-center gap-1.5" style={{ color: "var(--sj-primary)" }}><MessageSquareText className="h-4 w-4" /> Text your group</span>
        <span className="text-xs" style={{ color: "var(--sj-text-3)" }} data-testid="host-group-text-left">{left} of {status.limit} texts left this week</span>
      </div>
      <textarea data-testid="host-group-text-input" value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={300} rows={2} disabled={!left}
        placeholder={left ? "e.g. Reminder: we meet Thursday 7:30pm — see you there!" : "You've used this week's group texts"}
        className="mt-2 w-full bg-white border border-[#EBE9E4] rounded-lg px-3 py-2 text-sm outline-none focus:border-[#0B5E4E] disabled:opacity-60" />
      <div className="mt-2 flex items-center justify-between gap-2">
        <span className="text-xs" style={{ color: "var(--sj-text-3)" }}>{msg.length}/300</span>
        <button data-testid="host-group-text-send" disabled={busy || !left} onClick={send} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-white disabled:opacity-50" style={{ background: "var(--sj-primary)" }}><Send className="h-4 w-4" /> {busy ? "Sending…" : "Send text"}</button>
      </div>
      <GroupReplies endpoint="/portal/cell/group-replies" testid="host-group-replies" canReply />
    </div>
  );
};
